import { useEffect, useReducer } from 'react';

import { selectIsDesktop } from '~/components/brand/ducks/selectors';
import useTranslations from '~/components/translation/use-translations';
import CountDown, { TimingObject } from '~/utils/count-down';

import { useCasinoSharedSelector } from '../ducks/types';
import CardModal from './card-modal';
import HorizontalCardAvailable from './horizontal-card-available';
import HorizontalCardCountdown from './horizontal-card-countdown';
import { WidgetData } from './utils';

const TEXT_KEYS = [
	'WIDGET_PLAY_NOW',
	'WIDGET_DAYS_ABBREVIATION',
	'WIDGET_HOURS_ABBREVIATION',
	'WIDGET_MINUTES_ABBREVIATION',
	'WIDGET_SECONDS_ABBREVIATION',
	'REMINDER_SET',
	'REMIND_ME'
];

const Widget = (widget: WidgetData) => {
	const { translations, isLoadingTranslations } = useTranslations(TEXT_KEYS);
	const isDesktop = useCasinoSharedSelector(selectIsDesktop);
	const { modalOpen: notificationModalOpen } = useCasinoSharedSelector(state => state.exclusiveGameWidgets);

	const exploreGameItem = widget.exploreGameItems?.find(item => item.mobile === !isDesktop);

	const [showModal, toggleShowModal] = useReducer(state => {
		return !state;
	}, false);

	useEffect(() => {
		if (showModal && notificationModalOpen) {
			toggleShowModal();
		}
	}, [notificationModalOpen, showModal]);

	if (isLoadingTranslations || !exploreGameItem) {
		return null;
	}

	return (
		<CountDown
			date={widget.gameLaunch}
			renderer={(timingObject: TimingObject) => (
				<>
					{timingObject.completed ? (
						<HorizontalCardAvailable
							exploreGameItem={exploreGameItem}
							translations={translations}
							{...widget}
						/>
					) : (
						<HorizontalCardCountdown
							gameName={exploreGameItem?.name}
							timingObject={timingObject}
							toggleShowModal={toggleShowModal}
							translations={translations}
							{...widget}
						/>
					)}
					<CardModal
						open={showModal}
						toggleShowModal={toggleShowModal}
						gameName={exploreGameItem?.name}
						timingObject={timingObject}
						translations={translations}
						{...widget}
					/>
				</>
			)}
		/>
	);
};

export default Widget;
